import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from "@angular/forms";

import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-formulario-empresa",
  templateUrl: "./formulario.component.html"
})
export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tab = 1;
  tab2 = 1;
  tamano = document.body.clientHeight;
  form_contactos;
  form_redes_sociales;
  form_conversiones_monedas;

  form_impuestos;

  CFDI_PATH = environment.CFDI_PATH;

  CkeditorConfig = {
    height: document.body.clientHeight - 460
  };
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [1],
      configuracion: this.fb.group({
        nombre: [""],
        subnombre: [""],
        telefono: [""],
        correo: [""],
        direccion: [""],
        reintegro: [""],
        mensaje: [""],
        privacidad: [""],
        politicas_presupuesto: [""],
        mision: [""],
        vision: [""],
        quienes: [""],
        valores: [""],
        historia: [""],
        sitio: [""],
        url: [""],
        moneda: [""],
        folioT: [""],
        folioE: [""],
        dias_mes_anterior: [""],
        recibo: [""],
        control_lote: [""],
        notificar_caja_cerrada: [""],
        logo: [""],
        fondo: [""],
        utilidad: [""],
        intro_redes: [""],
        iframe_map: [""],

        video_promocional: this.fb.group({
          videoURL: ["j2rtMnB3oIg"],
          autoPlay: ["1"],
          startAt: ["6"],
          mute: ["1"],
          opacity: ["0.69"],
          containment: [".top_slider"]
        }),
        pensamientos: this.fb.array([]),
        contactos: this.fb.array([]),
        redes_sociales: this.fb.array([]),
        conversiones_monedas: this.fb.array([]),
        facturacion: this.fb.group({
          use_facturatelo: [""],
          pwd_facturatelo: [""],
          persona: [""],
          razon_social: [""],
          rfc: [""],
          lugar_expedicion: [""],
          regimen_fiscal: [""]
        }),
        impuestos: this.fb.group({
          traslados: this.fb.array([]),
          retenciones: this.fb.array([])
        })
      })
    });

    this.form_impuestos = {
      clave: "",
      nombre: "",
      factor: "",
      cuota: ""
    };

    this.form_contactos = {
      tipos_medios_id: ["1"],
      valor: ["", [Validators.required]]
    };

    this.form_redes_sociales = {
      tipos_redes_sociales_id: ["1"],
      valor: ["", [Validators.required]]
    };

    this.form_conversiones_monedas = {
      nombre: [""],
      moneda: ["", [Validators.required]],
      tipo_cambio: ["", [Validators.required]]
    };

    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
    let c = 0;
    let r = 0;
    this.dato.controls.configuracion.valueChanges.subscribe(val => {
      if (val.nombre && c == 0) {
        c++;
        setTimeout(() => {
          const ctrl = <FormGroup>this.dato.controls.configuracion;
          ctrl.controls.quienes.patchValue(
            this.dato.get("configuracion").value.quienes
          );
          ctrl.controls.mision.patchValue(
            this.dato.get("configuracion").value.mision
          );
          ctrl.controls.vision.patchValue(
            this.dato.get("configuracion").value.vision
          );
          ctrl.controls.historia.patchValue(
            this.dato.get("configuracion").value.historia
          );
          ctrl.controls.valores.patchValue(
            this.dato.get("configuracion").value.valores
          );
          ctrl.controls.privacidad.patchValue(
            this.dato.get("configuracion").value.privacidad
          );
        }, 500);
      }
    });

    this.dato.controls.configuracion["controls"].facturacion[
      "controls"
    ].persona.valueChanges.subscribe(val => {
      if (val && r == 0) {
        setTimeout(() => {
          document.getElementById("regimen").click();
        }, 100);
        r++;
      }
    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }
  seleccionar_persona(persona) {
    this.dato.controls.configuracion["controls"].facturacion[
      "controls"
    ].persona.patchValue(persona);
    setTimeout(() => {
      document.getElementById("regimen").click();
    }, 100);
  }
}
